// Single source of truth for the backend URL. Set REACT_APP_API_URL (see .env.example).
const raw = process.env.REACT_APP_API_URL;

if (!raw && process.env.NODE_ENV !== "test") {
  // eslint-disable-next-line no-console
  console.error("Missing environment variable REACT_APP_API_URL. See .env.example");
}

export const API_URL = (raw || "").replace(/\/+$/, "");
